import placeholder from '../images/Profile/placeholder.png';
import registersuccess from '../images/Register/register_success.png';

export const Placeholder = placeholder;
export const RegisterSuccess = registersuccess;
